module.exports = __webpack_public_path__ + "img/delete.1907d9d1.svg";